/* eslint-disable no-inline-comments */
/* eslint-disable max-len */

import { isIOS } from 'react-device-detect'

import { Provider } from 'modules/transmission/types'

export const EMBED_PARAMS: {[provider in Provider]?: string[]} = {
  [Provider.HOTMART]: [
    'autoplay=true'
  ],
  [Provider.VIMEO]: [
    'autoplay=1',
    'muted=1'
  ],
  [Provider.YOUTUBE]: [
    'autoplay=1',
    'showinfo=0',
    'modestbranding=1',
    ...(isIOS
      ? [] // On iOS devices, do not include 'mute=1' due to an issue where the video may revert to muted after a few seconds.
      : ['mute=1'] // For other devices, start the video muted to allow autoplay and potential user interaction.
    )
  ]
}

export const YOUTUBE_URL_REGEX = {
  REGULAR: /^((http|https):\/\/)?(www\.)?(youtube\.com\/)(watch\?v=)/,
  SHORT: /^((http|https):\/\/)?(youtu.be\/)/,
  FULLSCREEN_PLAYER: /^((http|https):\/\/)?(www\.)?(youtube\.com\/v\/)/,
  LIVE: /^\S+\/live\//
}

export const VIMEO_REGEX = /^((http|https):\/\/)?(www\.)?(vimeo\.com\/)(event\/)?/

export const YOUTUBE_EMBED_URL = 'https://www.youtube.com/embed/:id'
export const VIMEO_EMBED_URL = 'https://player.vimeo.com/video/:id'
export const VIMEO_EVENT_EMBED_URL = 'https://vimeo.com/event/:id/embed'
